import { Form, Spin, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  ThirdPartyRequest,
  createThirdParty,
  updateThirdParty,
} from 'services/thirdParty';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import ActivityList from './components/Activity/ActivityList';
import AddressList from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyDetailSFS/components/Addresse/AddressList';
import BankAccountList from './components/BankAccount/BankAccountList';
import ContactsList from './components/Contact/ContactsList';
import DF from 'DisplayFramework';
import Dashboard from './components/Dashboard/Dashboard';
import DemandSubTab from 'pages/ProposalV3/Components/DemandSubTab';
import ContractSubTab from 'pages/ProposalV3/Components/ContractSubTab';
import Flow from './components/Relations/Relation';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Notifications from 'components/theme_components/Notifications';
import ReservationSubTab from 'pages/ProposalV3/Components/ReservationSubTab';
import SiloList from './components/Silo/SiloList';
import TabPane from 'antd/es/tabs/TabPane';
import { ViewEntityAddAttributeResponse } from 'services/assetconfig';
import { getMyWizards } from 'services/workflow';
import { isNil } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { useGetThirdPartyDetail } from 'pages/ThirdParty/ThirdPartyDetail/useGetThirdPartyDetail';
import { useQuery } from 'react-query';
import PMActivityList from './components/Activity/PMActivityList';

export type ThirdPartyDetailsSFSProps = {};
const ThirdPartyDetailsSFS = () => {
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);

  const [percentageConsumedVN, setPercentageConsumedVN] = useState(0);
  const [percentageConsumedVD, setPercentageConsumedVD] = useState(0);
  const [percentageConsumedVO, setPercentageConsumedVO] = useState(0);
 const [activeTabKey, setActiveTabKey] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tab') || '1';
  });
  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
    navigate(`?tab=${key}`);
  };

  // Callback for when a tab is activated
  const handleTabActivated = (tabKey: string) => {
    console.log(`Tab ${tabKey} activated and data refreshed`);
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveKey(params.get('tab') || '1');
  }, [location.search]);
  const [form] = useForm();
  // const [tptype, settptype] = useState<string>('');
  let { id, tptype } = useParams<{
    id: string;
    tptype: 'CONC' | 'PM' | 'SPM';
  }>();
  const getId = () => {
    return id;
  };

  id = getId() as any;

  const [itemsCompanyHierarchyTree, setItemsCompanyHierarchyTree] = useState<
    any[]
  >([]);

  const { data, refetch, isFetching } = useGetThirdPartyDetail(
    isNaN(Number(id)) ? undefined : Number(id),
    'TP'
  );
  var thirdParty = data;
  const { data: wizData } = useQuery(['getMyWizards', 'THIRDPARTY'], () =>
    getMyWizards({ entity: 'THIRDPARTY' }).then((res) => res.data)
  );

  const flattenObjectToList = (obj: any) => {
    const result: any[] = [];

    const traverse = (node: any) => {
      if (!node) return;

      // Ajout de l'objet courant à la liste
      const { child, ...current } = node; // On extrait "child" pour éviter la récursivité infinie
      result.push(current);

      // Parcours du nœud enfant
      if (node.child) {
        traverse(node.child);
      }
    };

    traverse(obj);
    return result;
  };

  useEffect(() => {
    if (thirdParty) {
      // thirdParty.companyHierarchyTree
      const list = flattenObjectToList(thirdParty.companyHierarchyTree);
      setItemsCompanyHierarchyTree(list);
      form.setFieldsValue({
        tpclass: thirdParty?.generalData?.tpclass,
        tpclasslabel: thirdParty?.generalData?.tpclasslabel,
        tpclassdate: thirdParty?.generalData?.tpclassdate,
        tprevenue: thirdParty?.generalData?.tprevenue,
        tprevenuereferenceyear: toDatePickerDate(
          thirdParty?.generalData?.tprevenuereferenceyear
        ),
        tpidentitycardcountry: thirdParty?.generalData?.tpidentitycardcountry,
        tpidentitycardexpirationdate: toDatePickerDate(
          thirdParty?.generalData?.tpidentitycardexpirationdate
        ),
        tpactivitysector: thirdParty?.generalData?.tpactivitysector,
        tpflagresident: thirdParty?.generalData?.tpflagresident,
        tpcategory: thirdParty?.generalData?.tpcategory,
        tpcompanysize: thirdParty?.generalData?.tpcompanysize,
        tpparentcompanyid: thirdParty?.additionalInfo?.tpparentcompanyid,
        tpparentcompanyname: thirdParty?.generalData?.tpparentcompanyname,
        tpfree1: thirdParty?.additionalInfo?.tpfree1,
        tpfree2: thirdParty?.additionalInfo?.tpfree2,
        tpfree3: thirdParty?.additionalInfo?.tpfree3,
        tpfree4: thirdParty?.additionalInfo?.tpfree4,
        tpfree5: thirdParty?.additionalInfo?.tpfree5,
        tpdescription: thirdParty?.additionalInfo?.tpdescription,
        tpid: thirdParty?.generalData?.tpid,
        currcode: thirdParty?.generalData?.currcode,
        tpreference: thirdParty?.generalData?.tpreference,
        tptype: thirdParty?.generalData?.tptype,
        tptypelabel: thirdParty?.generalData?.tptypelabel,

        tpkycstatuslabel: thirdParty?.generalData?.tpkycstatuslabel,
        tpkycstatus: thirdParty?.generalData?.tpkycstatus,
        tpkycdate: thirdParty?.generalData?.tpkycdate?.substring(0, 10),
        tpstatuslabel: thirdParty?.generalData?.tpstatuslabel,
        tpstatus: thirdParty?.generalData?.tpstatus,
        tpstatusdate: thirdParty?.generalData?.tpstatusdate?.substring(0, 10),
        tpstatuslabelgeneraldata:
          thirdParty?.generalData?.tpstatuslabel +
          ' (' +
          thirdParty?.generalData?.tpstatusdate?.substring(0, 10) +
          ')',
        tpbrokerid: thirdParty?.generalData?.tpbrokerid,
        tplegalform: thirdParty?.generalData?.tplegalform,
        tpname: thirdParty?.generalData?.tpname,
        tpsurname: thirdParty?.generalData?.tpsurname,
        tpmiddlename: thirdParty?.generalData?.tpmiddlename,
        tpmaidenname: thirdParty?.generalData?.tpmaidenname,
        tpmarketingname: thirdParty?.generalData?.tpmarketingname,
        tpmanagername: thirdParty?.generalData?.tpmanagername,
        tpmanagerposition: thirdParty?.generalData?.tpmanagerposition,
        tpactivity: thirdParty?.generalData?.tpactivity,
        tpbranchid: thirdParty?.generalData?.tpbranchid,
        mgid: thirdParty?.generalData?.mgid,
        lancode: thirdParty?.generalData?.lancode,
        countcode: thirdParty?.generalData?.countcode,
        tpcompanycreationdate: toDatePickerDate(
          thirdParty?.generalData?.tpcompanycreationdate
        ),
        tpflagvatexemption: thirdParty?.generalData?.tpflagvatexemption,
        tpvatexemtionenddate: toDatePickerDate(
          thirdParty?.generalData?.tpvatexemtionenddate
        ),
        tpfiscalid: thirdParty?.generalData?.tpfiscalid,
        tpfiscalcity: thirdParty?.generalData?.tpfiscalcity,
        tptaxid: thirdParty?.generalData?.tptaxid,
        tpsalutationcode: thirdParty?.generalData?.tpsalutationcode,
        tpgender: thirdParty?.generalData?.tpgender,
        tpbirthdate: toDatePickerDate(thirdParty?.generalData?.tpbirthdate),
        tpbirthcity: thirdParty?.generalData?.tpbirthcity,
        tpbirthcountry: thirdParty?.generalData?.tpbirthcountry,
        tpprofession: thirdParty?.generalData?.tpprofession,
        tpidentitycardtype: thirdParty?.generalData?.tpidentitycardtype,
        tpidentitycardid: thirdParty?.generalData?.tpidentitycardid,
        tpmaritalstatus: thirdParty?.generalData?.tpmaritalstatus,
        tpnbofchildren: thirdParty?.generalData?.tpnbofchildren,
        tpworkingctdate: toDatePickerDate(
          thirdParty?.generalData?.tpworkingctdate
        ),
        tpworkingcttype: thirdParty?.generalData?.tpworkingcttype,
        tporigin: thirdParty?.generalData?.tporigin,
        tpspecialtag: thirdParty?.generalData?.tpspecialtag,

        parentCompany: {
          tpid: thirdParty?.generalData?.tpparentcompanyid,
          tpname: thirdParty?.generalData?.tpparentcompanyidname,
          tpreference: thirdParty?.generalData?.tpparentcompanyidreference,
        },
        tptradingid: thirdParty?.generalData?.tptradingid,
        tpcompanyid: thirdParty?.generalData?.tpcompanyid,

        tpparentcompanyidreference:
          thirdParty?.generalData?.tpparentcompanyidreference,
        tpparentcompanyidname: thirdParty?.generalData?.tpparentcompanyidname,
        tpcapital: thirdParty?.generalData?.tpcapital,
        tpbrand: thirdParty?.generalData?.tpbrand,
        tpcapitalholding: Number(thirdParty?.generalData?.tpcapitalholding),
        tppoliticallyexposedperson:
          thirdParty?.generalData?.tppoliticallyexposedperson,
        tpantimoneylaunder: thirdParty?.generalData?.tpantimoneylaunder,
        tpmainadrstreet1: thirdParty?.address?.tpmainadrstreet1 ?? '',
        tpmainadrstreet2: thirdParty?.address?.tpmainadrstreet2 ?? '',
        tpmainadrcity: thirdParty?.address?.tpmainadrcity ?? '',
        tpmainadrcitylabel: thirdParty?.address?.tpmainadrcitylabel ?? '',
        tpmainadrzipcode: thirdParty?.address?.tpmainadrzipcode ?? '',
        tpmainadrregion: thirdParty?.address?.tpmainadrregion ?? '',
        tpmainadrregionglobale:
          thirdParty?.address?.tpmainadrregionglobale ?? '',
        tpmainadrcountry: thirdParty?.address?.tpmainadrcountry ?? '',
        tpmainadrcountrylabel: thirdParty?.address?.tpmainadrcountrylabel ?? '',
        tpsecadrstreet1: thirdParty?.address?.tpsecadrstreet1,
        tpsecadrstreet2: thirdParty?.address?.tpsecadrstreet2,
        tpsecadrcity: thirdParty?.address?.tpsecadrcity,
        tpsecadrzipcode: thirdParty?.address?.tpsecadrzipcode,
        tpsecadrregion: thirdParty?.address?.tpsecadrregion,
        tpsecadrcountry: thirdParty?.address?.tpsecadrcountry,
        bkaccountkeymain: thirdParty?.bankAccount?.bkaccountkey,
        bkaccountnummain: thirdParty?.bankAccount?.bkaccountnum,
        bkbranchcodemain: thirdParty?.bankAccount?.bkbranchcode,
        bkcodemain: thirdParty?.bankAccount?.bkcode,
        bktypemain: thirdParty?.bankAccount?.bktype,
        tpibanmain: thirdParty?.bankAccount?.tpiban,
        tpbicmain: thirdParty?.bankAccount?.tpbic,
        tpbanknamemain: thirdParty?.bankAccount?.tpbankname,
        tpcbtype: thirdParty?.bankAccount?.tpcbtype,
        tpcbnummain: thirdParty?.bankAccount?.tpcbnum,
        tpcbdatemain: thirdParty?.bankAccount?.tpcbdate,
        tpcbkeymain: thirdParty?.bankAccount?.tpcbkey,
        tpcbnamemain: thirdParty?.bankAccount?.tpcbname,
        tptel1: thirdParty?.contact?.tptel1,
        tptelmobile1: thirdParty?.contact?.tptelmobile1,
        tpemail1: thirdParty?.contact?.tpemail1,
        tpcontactname1: thirdParty?.contact?.tpcontactname1,
        tpcontactposition1: thirdParty?.contact?.tpcontactposition1,
        tptel2: thirdParty?.contact?.tptel2,
        tptelmobile2: thirdParty?.contact?.tptelmobile2,
        tpemail2: thirdParty?.contact?.tpemail2,
        tpcontactname2: thirdParty?.contact?.tpcontactname2,
        tpcontactposition2: thirdParty?.contact?.tpcontactposition2,
        tpsaleuserid: thirdParty?.correspondent?.tpsaleuserid,
        tpsaleusername: thirdParty?.correspondent?.tpsaleusername,
        tpsaleuserdate: thirdParty?.correspondent?.tpsaleuserdate?.substring(
          0,
          10
        ),
        tpriskuserid: thirdParty?.correspondent?.tpriskuserid,
        tpriskusername: thirdParty?.correspondent?.tpriskusername,
        tpriskuserdate: thirdParty?.correspondent?.tpriskuserdate?.substring(
          0,
          10
        ),
        tpbouserid: thirdParty?.correspondent?.tpbouserid,
        tpbousername: thirdParty?.correspondent?.tpbousername,
        tpbouserdate: thirdParty?.correspondent?.tpbouserdate?.substring(0, 10),
        tprecuserid: thirdParty?.correspondent?.tprecuserid,
        tprecusername: thirdParty?.correspondent?.tprecusername,
        tprecuserdate: thirdParty?.correspondent?.tprecuserdate?.substring(
          0,
          10
        ),
        tplpuserid: thirdParty?.correspondent?.tplpuserid,
        tplpusername: thirdParty?.correspondent?.tplpusername,
        tplpuserdate: thirdParty?.correspondent?.tplpuserdate?.substring(0, 10),
        tpemployer: thirdParty?.income?.tpemployer,
        tpemployeraddress: thirdParty?.income?.tpemployeraddress,
        tpemloyertel: thirdParty?.income?.tpemloyertel,
        tpmonthlyincome: thirdParty?.income?.tpmonthlyincome,
        tpothersincome: thirdParty?.income?.tpothersincome,
        tpfamilybenefits: thirdParty?.income?.tpfamilybenefits,
        tpothersexpense: thirdParty.income?.tpothersexpense,
        tpotherloan: thirdParty?.income?.tpotherloan,
        tpflagclient: thirdParty?.role?.tpflagclient,
        tpflagsupplier: thirdParty?.role?.tpflagsupplier,
        tpflagguarantor: thirdParty?.role?.tpflagguarantor,
        tproleother: thirdParty?.role?.tproleother,
        tppaymodein: thirdParty?.role?.tppaymodein,
        tppaydelayin: thirdParty?.role?.tppaydelayin,
        tppaymodeout: thirdParty?.role?.tppaymodeout,
        tppaydelayout: thirdParty?.role?.tppaydelayout,
        tplateinterestformula: thirdParty?.role?.tplateinterestformula,
        tpblocklateinterestinvoicing:
          thirdParty.role?.tpblocklateinterestinvoicing,
        tpreminderfeesformula: thirdParty?.role?.tpreminderfeesformula,
        tpblockreminderfeesinvoicing:
          thirdParty?.role?.tpblockreminderfeesinvoicing,
        tpblockrejectionfeesinvoicing:
          thirdParty?.role?.tpblockrejectionfeesinvoicing,
        tprejectionfeesformula: thirdParty?.role?.tprejectionfeesformula,

        spname: thirdParty?.spouse?.spname,
        spsurname: thirdParty?.spouse?.spsurname,
        spgender: thirdParty?.spouse?.spgender,
        spbirthdate: toDatePickerDate(thirdParty?.spouse?.spbirthdate),
        spbirthcity: thirdParty?.spouse?.spbirthcity,
        spbirthcountry: thirdParty?.spouse?.spbirthcountry,
        spmaidenname: thirdParty?.spouse?.spmaidenname,

        spsalutationcode: thirdParty?.spouse?.spsalutationcode,
        spfiscalid: thirdParty?.spouse?.spfiscalid,
        spprofession: thirdParty?.spouse?.spprofession,
        spidentitycardtype: thirdParty?.spouse?.spidentitycardtype,
        spidentitycardid: thirdParty?.spouse?.spidentitycardid,
        spemployer: thirdParty?.spouse?.spemployer,
        spemployeraddress: thirdParty?.spouse?.spemployeraddress,
        spemloyertel: thirdParty?.spouse?.spemloyertel,
        spmonthlyincome: thirdParty?.spouse?.spmonthlyincome,
        spothersincome: thirdParty?.spouse?.spothersincome,
        spothersexpense: thirdParty?.spouse?.spothersexpense,
        spotherloan: thirdParty?.spouse?.spotherloan,
        tpsalestatuslabel: thirdParty?.status?.tpsalestatuslabel,
        tpsalestatusdate: thirdParty?.status?.tpsalestatusdate?.substring(
          0,
          10
        ),
        tpriskstatuslabel: thirdParty?.status?.tpriskstatuslabel,
        tpriskstatusdate: thirdParty?.status?.tpriskstatusdate?.substring(
          0,
          10
        ),
      });

      ///
      let perConsumedVN =
        thirdParty?.authResponse?.find((item) => item.prcode === 'VN')
          ?.percentage ?? 0;
      let perConsumedVD =
        thirdParty?.authResponse?.find((item) => item.prcode === 'VD')
          ?.percentage ?? 0;
      let perConsumedVO =
        thirdParty?.authResponse?.find((item) => item.prcode === 'VO')
          ?.percentage ?? 0;

      setPercentageConsumedVN(perConsumedVN);
      setPercentageConsumedVO(perConsumedVO);
      setPercentageConsumedVD(perConsumedVD);

      if (!isNil(thirdParty?.entityAddAttributList)) {
        let test = {};

        thirdParty?.entityAddAttributList?.forEach(
          (att: ViewEntityAddAttributeResponse) => {
            let value: any;

            if (att.attdatatype === 'STRING') {
              value = att.attstringvalue;
            } else if (att.attdatatype === 'LONG') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'DOUBLE') {
              value = att.attnumericvalue;
            } else if (att.attdatatype === 'BOOLEAN') {
              value = att.attbooleanvalue;
            } else if (att.attdatatype === 'TEXT') {
              value = att.atttextvalue;
            } else if (att.attdatatype === 'DATE') {
              if (moment(att.attstringvalue, false).isValid()) {
                value = moment(att.attstringvalue, false);
              } else {
                value = null;
              }
            }

            let obj = { [att.attcode]: value };
            test = { ...test, ...obj };
          }
        );
        form.setFieldsValue({ entityAddAttributList: test });
      }
    }
  }, [thirdParty, tptype]);

  const [color, setColor] = useState<string>();

  const [activeKey, setActiveKey] = useState<string>('1');

  useEffect(() => {
    setActiveKey('1');
    if (tptype === 'CONC') {
      setColor('green');
    } else if (tptype === 'PM') {
      setColor('duck-blue');
    } else if (tptype === 'SPM') {
      setColor('blue');
    }
  }, [tptype, id]);

  return (
    <DF.Provider
      pagcode="tpdetailsfs"
      entity="THIRDPARTY"
      additionalAttribute={{
        entity: 'THIRDPARTY',
        object: 'THIRDPARTY',
      }}
    >
      <Spin spinning={isFetching}>
        <Form layout="vertical" form={form}>
          <Tabs
            className={`tabs-border-top bg-color-gray mb-50 ${
              id ? 'hide-tab' : ''
            }`}
            activeKey={activeTabKey}
            onChange={handleTabChange}
          >
            <TabPane
              forceRender
              tab={<GetLabel label="Dashboard" className="font-size-15" />}
              key="1"
            >
              <Dashboard
                form={form}
                color={color ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                tptype={tptype}
                percentageConsumedVN={percentageConsumedVN}
                percentageConsumedVO={percentageConsumedVO}
                percentageConsumedVD={percentageConsumedVD}
              />
            </TabPane>
            <TabPane
              tab={<GetLabel label="Limites" className="font-size-15" />}
              key="2"
            >
                {/* {tptype==='PM'?<PMActivityList
                tpid={Number(id) ?? 0}
                tptype={tptype ?? ''}
                form={form}
                color={color ?? ''}
                tpbrand={form.getFieldValue('tpbrand') ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
              />: */}
              <ActivityList 
                tpid={Number(id) ?? 0}
                tptype={tptype ?? ''}
                form={form}
                color={color ?? ''}
                tpbrand={form.getFieldValue('tpbrand') ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
              />
            </TabPane>
            {tptype == 'CONC' ? (
              <TabPane
                tab={
                  <GetLabel
                    label="information bancaires"
                    className="font-size-15"
                  />
                }
                key="3"
              >
                <BankAccountList
                  tptype={tptype ?? ''}
                  form={form}
                  color={color ?? ''}
                  tpid={Number(id) ?? 0}
                  itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                />
              </TabPane>
            ) : (
              <TabPane
                tab={<GetLabel label="silo" className="font-size-15" />}
                key="3"
              >
                <SiloList
                  tpid={Number(id)}
                  form={form}
                  color={color ?? ''}
                  itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                  tptype={tptype}
                />
              </TabPane>
            )}
            <TabPane
              tab={<GetLabel label="Adresses" className="font-size-15" />}
              key="4"
            >
              <AddressList
                tptype={tptype ?? ''}
                tpid={id ?? form.getFieldValue('tpid')}
                form={form}
                color={color ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                onDone={undefined}
              />
            </TabPane>
            <TabPane
              tab={<GetLabel label="Contacts" className="font-size-15" />}
              key="5"
            >
              <ContactsList
                tptype={tptype ?? ''}
                tpid={id ?? form.getFieldValue('tpid')}
                form={form}
                color={color ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
              />
            </TabPane>
            <TabPane
              tab={<GetLabel label="oustsandings" className="font-size-15" />}
              key="6"
            >
              <ContractSubTab
                form={form}
                tpauthid={0}
                color={color ?? ''}
                tptype={tptype ?? ''}
                tpid={id ?? form.getFieldValue('tpid')}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                isActive={activeTabKey === '6'}
                onTabActivated={() => handleTabActivated('6')}
              />
            </TabPane>
            <TabPane
              tab={<GetLabel label="reservations" className="font-size-15" />}
              key="7"
            >
              <ReservationSubTab
                form={form}
                tpauthid={0}
                color={color ?? ''}
                tpid={id ?? form.getFieldValue('tpid')}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                tptype={tptype}
                isActive={activeTabKey === '7'}
                onTabActivated={() => handleTabActivated('7')}
              />
            </TabPane>
            <TabPane
              tab={<GetLabel label="demands" className="font-size-15" />}
              key="8"
            >
              <DemandSubTab
                form={form}
                color={color ?? ''}
                tpid={id ?? form.getFieldValue('tpid')}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                isActive={activeTabKey === '8'}
                onTabActivated={() => handleTabActivated('8')}
              />
            </TabPane>

            <TabPane
              tab={<GetLabel label="Relations" className="font-size-15" />}
              key="9"
            >
              <Flow
                tpid={id ?? form.getFieldValue('tpid')}
                form={form}
                color={color ?? ''}
                itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
                setActiveTab={setActiveTabKey}
              />
            </TabPane>
          </Tabs>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default ThirdPartyDetailsSFS;
